export default "__VITE_ASSET__PlJXiITp__"